import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Actions
import { getProductDetails } from "../redux/actions/productActions";
import { addToCart } from "../redux/actions/cartActions";
import { useParams } from "react-router-dom";
import { Button, message, Rate, Spin, Tabs } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import Product from "../components/Product";
import Breadcrumb from "../components/Breadcrumb";
// import Magnifier from "react-magnifier";

const ProductScreen = ({ match, storeCurrency }) => {
  const [qty, setQty] = useState(1);
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useNavigate();
  const products = useSelector((state) => state.getProducts)?.products;
  const productDetails = useSelector((state) => state.getProductDetails);
  const [image, setImage] = useState("");
  const { loading, product } = productDetails;

  useEffect(() => {
    if (product && id !== product._id) {
      dispatch(getProductDetails(id));
    }
  }, [dispatch, match, product, id]);

  const addToCartHandler = () => {
    dispatch(addToCart(product._id, qty));
    history(`/cart`);
  };

  const increase = () => {
    if (qty === product.countInStock) {
      message.error("Out of stock!");
    } else {
      setQty(qty + 1);
    }
  };

  const decline = () => {
    let newCount = qty - 1;
    if (newCount < 1) {
      newCount = 1;
      message.error("Minimum 1 is required!");
    }
    setQty(newCount);
  };

  return (
    <div>
      <Breadcrumb heading={product?.name} name="Products - " />
      <div className="container mx-auto">
        <Spin spinning={loading}>
          <>
            {product ? (
              <div className="container mx-auto py-20">
                <div className="md:grid grid-cols-2 gap-8 my-4 p-4">
                  <div>
                    <img
                      src={image ? image : product?.image}
                      alt={product?.name}
                      className="main_image"
                    />
                    <div className="flex flex-col mt-2 gap-4 overflow-x-auto">
                      <div
                        className="flex gap-2 mb-2"
                        style={{ maxWidth: 1200 }}
                      >
                        {image ? (
                          <img
                            src={product?.image}
                            alt={product?.name}
                            onClick={() => setImage(product?.image)}
                            className="main_image_sub"
                          />
                        ) : (
                          ""
                        )}
                        {product?.images?.length > 0
                          ? product?.images?.map((img, index) => (
                            <div key={index}>
                              <img
                                src={img}
                                alt={img}
                                onClick={() => setImage(img)}
                                className="main_image_sub"
                              />
                            </div>
                          ))
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div className="s_product_text">
                    <h1>{product.name}</h1>
                    <h2>
                      Price: {storeCurrency}
                      {product.price}
                    </h2>
                    <div className="pb-4 border-b m-0">
                      <Rate value={product.rating} disabled />{" "}
                    </div>
                    <ul className="border-b py-4">
                      <li>
                        <p className="p-2">
                          <span>Category</span> : {product.category?.name}
                        </p>
                      </li>
                      <li>
                        <p className="p-2">
                          <span>Availability</span> :{" "}
                          {product.countInStock > 0
                            ? "In Stock"
                            : "Out of Stock"}{" "}
                          ({product.countInStock})
                        </p>
                      </li>
                      <li>
                        <p className="p-2">
                          <span>SKU</span> : {product.sku}
                        </p>
                      </li>
                    </ul>
                    {/* <div
                    className="border-b py-4"
                    dangerouslySetInnerHTML={{
                      __html: `${product?.description?.substring(0, 90)}...`,
                    }}
                  /> */}
                    <div className="py-4 flex items-center gap-4">
                      <div className="flex">
                        <Button onClick={decline}>
                          <MinusOutlined />
                        </Button>
                        <div
                          className="w-8 px-5 h-8 border flex items-center justify-center"
                          onChange={(e) => setQty(e.target.value)}
                        >
                          {qty}
                        </div>
                        <Button onClick={increase}>
                          <PlusOutlined />
                        </Button>
                      </div>
                      {/* <select
                      className="border rounded px-6"
                      value={qty}
                      onChange={(e) => setQty(e.target.value)}
                    >
                      {[...Array(product.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </select> */}
                      <button
                        className="info__button"
                        onClick={addToCartHandler}
                      >
                        Add To Cart
                      </button>
                    </div>
                  </div>
                </div>
                <div className="pro-tabs my-20 p-4">
                  <Tabs defaultActiveKey="1" type="card">
                    <Tabs.TabPane tab="Description" key="1">
                      <div
                        className="border-b py-4"
                        dangerouslySetInnerHTML={{
                          __html: product?.description,
                        }}
                      />
                    </Tabs.TabPane>
                    {/* <Tabs.TabPane tab="Review" key="2">
                  <div className="border-b py-4">Add Review</div>
                </Tabs.TabPane> */}
                  </Tabs>
                </div>
                {products?.length > 0 ? (
                  <div className="container mx-auto">
                    <h2 className="heading_h2 text-center">
                      Featured Products
                    </h2>
                    <div className="md:grid grid-cols-4 gap-4 pt-20 md:m-0 m-4">
                      {products
                        ?.filter((product) => product?.isFeatured === true)
                        ?.slice(0, 4)
                        ?.map((product) => (
                          <Product
                            key={product._id}
                            name={product.name}
                            price={product.price}
                            image={product.image}
                            _id={product._id}
                            storeCurrency={storeCurrency}
                          />
                        ))}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </>
        </Spin>
      </div>
    </div>
  );
};

export default ProductScreen;
